export class ApiError extends Error {
  constructor(
    public status: number,
    message: string,
  ) {
    super(message);
  }
}
export async function api<T = any>(
  url: string,
  options: RequestInit = {},
): Promise<T> {
  const response = await fetch(url, {
    credentials: "same-origin",
    ...options,
    headers: {
      ...(options.body ? { "Content-Type": "application/json" } : {}),
      ...options.headers,
    },
  });
  const data = await response.json();
  if (!response.ok)
    throw new ApiError(response.status, data.error || "请求未完成");
  return data as T;
}
export const post = <T = any>(url: string, data: unknown = {}) =>
  api<T>(url, { method: "POST", body: JSON.stringify(data) });
export const patch = <T = any>(url: string, data: unknown) =>
  api<T>(url, { method: "PATCH", body: JSON.stringify(data) });
